import deepMerge from "@helper/deepMerge";

export function whitelistKeys(keys) {
  return (obj) =>
    Object.keys(obj || {}).reduce(
      (acc, key) => (keys.includes(key) ? { ...acc, [key]: obj[key] } : acc),
      {}
    );
}

export function blacklistKeys(keys) {
  return (obj) =>
    Object.keys(obj || {}).reduce(
      (acc, key) => (keys.includes(key) ? acc : { ...acc, [key]: obj[key] }),
      {}
    );
}

export function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}

export function mapObject(obj, mapFn) {
  if (!mapFn) return (o) => mapObject(o, obj);

  return Object.keys(obj).reduce(function (result, key) {
    result[key] = mapFn(obj[key], key);
    return result;
  }, {});
}

export function filterObject(obj, predFn) {
  if (!predFn) return (o) => filterObject(o, obj);

  return Object.keys(obj || {}).reduce(
    (acc, key) => (predFn(obj[key], key) ? { ...acc, [key]: obj[key] } : acc),
    {}
  );
}

export function dropObjectKey(obj, key) {
  return Object.keys(obj || {})
    .filter((k) => k !== key)
    .reduce((acc, k) => ({ ...acc, [k]: obj[k] }), {});
}

export function replaceRecursiveBySelector(original, selector, newValue) {
  if (!original) return original;

  if (typeof original === "object") {
    if (Array.isArray(original)) {
      return original.map((y) => {
        if (selector(y)) return deepMerge([y, newValue]);
        else return replaceRecursiveBySelector(y, selector, newValue);
      });
    } else {
      let retVal = {};
      const keys = Object.keys(original);
      for (let i = 0; i < keys.length; i++) {
        if (original[keys[i]] && selector(original[keys[i]]))
          retVal = {
            ...retVal,
            [keys[i]]: deepMerge([original[keys[i]], newValue]),
          };
        else {
          retVal = {
            ...retVal,
            [keys[i]]: replaceRecursiveBySelector(
              original[keys[i]],
              selector,
              newValue
            ),
          };
        }
      }
      return retVal;
    }
  }

  return original;
}

export function replaceRecursiveById(original, id, newValue) {
  return replaceRecursiveBySelector(original, (x) => x.id === id, newValue);
}
